import React from "react";
import { v4 as uuidv4 } from "uuid";

const CheckedCircle: React.FC = () => {
  const svgUuid = uuidv4();

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={`checkedCircleComponentIconTitle-${svgUuid}`}
      role="img"
    >
      <title id={`checkedCircleComponentIconTitle-${svgUuid}`}>
        Checked Circle
      </title>
      <desc id={`checkedCircleComponentIconDesc-${svgUuid}`}>
        A circle with a checkmark in it.
      </desc>
      <path
        d="M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12Z"
        fill="black"
        stroke="black"
      />
      <path
        d="M15.6275 9.94986L15.9441 9.56288L15.5572 9.24626L14.7832 8.61302L14.3962 8.2964L14.0796 8.68338L10.2793 13.3282L9.06066 12.1095L8.70711 11.756L8.35355 12.1095L7.64645 12.8166L7.29289 13.1702L7.64645 13.5237L10.0371 15.9144L10.4278 16.3051L10.7777 15.8775L15.6275 9.94986Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
};

export default CheckedCircle;
